/**
 * @private
 * Enum for Social Identities
 */
export const SocialIdentity = {
  Kinvey: 'kinvey',
  MobileIdentityConnect: 'kinveyAuth',
};
Object.freeze(SocialIdentity);



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/identity/enums.js